import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/caixasaida",
    name: "CaixaSaida",
    props: { homepage: true},
    beforeEnter: routeGuard,
    component: () => import("../views/index.vue"),
	}
]